import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=2d91e0c3&scoped=true&"
import script from "./UserProfile.vue?vue&type=script&lang=js&"
export * from "./UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=2d91e0c3&prod&lang=scss&scoped=true&"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=2d91e0c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91e0c3",
  null
  
)

export default component.exports